import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router/composables";

import { checkIsRouteAuthorized } from "@/security/authorization";

import TheNavbarMenuDocumentTab from "./TheNavbarMenuDocumentTab.vue";
import TheNavbarMenuOntologyTab from "./TheNavbarMenuOntologyTab.vue";
import TheNavbarMenuProjectTab from "./TheNavbarMenuProjectTab.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheNavbarMenu',
  setup(__props) {

const isMenuVisible = ref<boolean>(false);
const selectedTab = ref<number>(0);

const route = useRoute();
const currentFullPath = computed<string>(() => {
  return route.fullPath;
});

watch(currentFullPath, (): void => {
  isMenuVisible.value = false;
});

return { __sfc: true,isMenuVisible, selectedTab, route, currentFullPath, checkIsRouteAuthorized, TheNavbarMenuDocumentTab, TheNavbarMenuOntologyTab, TheNavbarMenuProjectTab }
}

})